import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Title } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Title);

const Piechart = ({
  endpoint, // API endpoint to fetch data
  labelMap, // Array of { key, label }
  valueAccessor, // Function to extract values + total
  title = "total", // Center text under total value
}) => {
  const [values, setValues] = useState([]);
  const [tot, setTotal] = useState(0);

  // Static color palette (4 shades of green)
  const greenShades = ["#365314", "#4c6b1d", "#628325", "#799c2e"];

  useEffect(() => {
    const fetchAndFormat = async () => {
      try {
        const res = await fetch(endpoint);
        const data = await res.json();

        if (valueAccessor) {
          const { values: vals, tot: total } = valueAccessor(data);
          setValues(vals);
          setTotal(total);
        }
      } catch (err) {
        console.error("Error fetching data for piechart:", err);
      }
    };

    fetchAndFormat();
  }, [endpoint, labelMap, valueAccessor]);

  const data = {
    labels: labelMap.map((d) => d.label),
    datasets: [
      {
        data: values,
        backgroundColor: greenShades.slice(0, labelMap.length),
        borderWidth: 0,
        cutout: "75%",
      },
    ],
  };

  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const { width, height, ctx } = chart;
      ctx.save();
      ctx.font = "bold 24px Inter";
      ctx.fillStyle = "#ffffff";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(`${Math.round(tot)}`, width / 2, height / 2 - 10);
      ctx.font = "14px Inter";
      ctx.fillText(title, width / 2, height / 2 + 15);
    },
  };

  const options = {
    plugins: {
      legend: { display: true },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.raw.toFixed(2)}`,
        },
      },
    },
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <div style={{ width: "280px", height: "280px", position: "relative" }}>
        <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
      </div>

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          width: "100%",
          maxWidth: "260px",
        }}
      >
        {labelMap.map(({ label }, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "14px",
              color: "#e4e4e7",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: greenShades[i],
                }}
              />
              {label}
            </div>
            <div style={{ fontWeight: 600 }}>{values[i]?.toFixed(2)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Piechart;
